import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  BuitenlandseBronheffing,
  IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {optionsLandcodesZonderNLD} from "../../gedeelde-componenten/gedeelde-componenten.component";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { filter, Subscription} from "rxjs";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-buitenlandse-bronheffing',
  templateUrl: './buitenlandse-bronheffing.component.html',
  styleUrls: ['./buitenlandse-bronheffing.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class BuitenlandseBronheffingComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesZonderNLD;

    public buitenlandseBronheffing = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.buitenlandseBronheffing = this.fb.group({
            bronheffingBtl: this.fb.array<BuitenlandseBronheffing>([]),
        });
    }

    get bronheffingBtl(): FormArray {
        return this.buitenlandseBronheffing.get('bronheffingBtl') as FormArray;
    }

    addRijBronheffingBtl(): void {
        this.bronheffingBtl.push(this.createBronheffingBtlFormGroup())
    }

    verwijderRijBronheffingBtl(index: number): void {
        this.bronheffingBtl.removeAt(index);
        this.buitenlandseBronheffing.updateValueAndValidity()
        this.buitenlandseBronheffing.markAsDirty()
        this.saveForm()
    }

    createBronheffingBtlFormGroup(bronheffing?: BuitenlandseBronheffing): FormGroup {
        return this.fb.group<BuitenlandseBronheffing>({
            rekeningNummer: bronheffing?.rekeningNummer || undefined,
            landCode: bronheffing?.landCode ?? '',
            buitenlandseRente: bronheffing?.buitenlandseRente || undefined,
            bronbelastingOpRente: bronheffing?.bronbelastingOpRente || undefined,
            buitenlandsDividendbox2: bronheffing?.buitenlandsDividendbox2 || undefined,
            bronbelastingOpDividendbox2: bronheffing?.bronbelastingOpDividendbox2 || undefined,
            buitenlandsDividendbox3: bronheffing?.buitenlandsDividendbox3 || undefined,
            bronbelastingOpDividendbox3: bronheffing?.bronbelastingOpDividendbox3 || undefined
        })
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm();
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
       });
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.buitenlandseBronheffing.dirty
    }

    private updateForm(): void {
        const bronbelastingLijst = this.aangifte?.voorheffingen?.buitenlandseBronheffing || [];
        const formArray = this.buitenlandseBronheffing.get('bronheffingBtl') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > bronbelastingLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < bronbelastingLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(bronbelastingLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createBronheffingBtlFormGroup(bronbelastingLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }


    saveForm(): void {
        this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            voorheffingen: {
                ...this.aangifte.voorheffingen,
                buitenlandseBronheffing: this.buitenlandseBronheffing.value.bronheffingBtl
            }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }

}



